export default __webpack_public_path__ + "static/Front_banner-a77661127149c5f304c9609b2af7d33a.svg";